import React, { forwardRef } from "react";

import type { BasicTextInputProps } from "@/components/botanic/BasicTextInput";
import BasicTextInput from "@/components/botanic/BasicTextInput";
import FormElementErrorMessage from "@/components/botanic/FormElementErrorMessage";
import FormLabel from "@/components/botanic/FormLabel";
import FormField from "@/components/FormField";

export type TextInputProps = BasicTextInputProps & {
  label?: React.ReactNode;
  labelClasses?: string;
  helperText?: string;
  errorMessage?: string;
};

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      id,
      label,
      labelClasses,
      helperText,
      errorMessage,
      className,
      autoFocus,
      ...inputProps
    },
    ref,
  ) => {
    const showError = Boolean(errorMessage);

    return (
      <div className="py-2">
        <FormField>
          {label && (
            <FormLabel
              htmlFor={id}
              style={showError ? { color: "#dc2626" } : undefined}
              hasError={showError}
              className={labelClasses}
            >
              {label}
            </FormLabel>
          )}

          <BasicTextInput
            id={id}
            ref={ref}
            autoFocus={autoFocus}
            className={className}
            {...inputProps}
          />

          {helperText && !showError && (
            <p className="text-xs text-gray-500">{helperText}</p>
          )}

          {errorMessage && <FormElementErrorMessage message={errorMessage} />}
        </FormField>
      </div>
    );
  },
);

TextInput.displayName = "TextInput";

export default TextInput;
